import React from 'react';
import {
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
} from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

type PlaceholderTypeWhenConvertedToTsx = any;

interface IProps {
  availableTabs: PlaceholderTypeWhenConvertedToTsx;
  setActiveTab: PlaceholderTypeWhenConvertedToTsx;
  routes: PlaceholderTypeWhenConvertedToTsx;
  jumpToIndex: PlaceholderTypeWhenConvertedToTsx;
  currentTabIndex: PlaceholderTypeWhenConvertedToTsx;
}

const MealDetailedViewTabs = (props: IProps) => {
  const {
    availableTabs,
    setActiveTab,
    routes,
    jumpToIndex,
    currentTabIndex,
  } = props;
  return (
    <View style={styles.container}>
      {routes.map((route, index) => {
        const activeTab = availableTabs[index];
        const active = index === currentTabIndex;

        const backgroundColor = Theme.WHITE;

        const textColor = active
          ? Theme.PRIMARY
          : Theme.TEXT_DARK;

        const fontFamily = Theme.Weight400;

        const borderInactiveStyles = {
          borderWidth: 1,
          borderLeftWidth: index === 0 ? 1 : 0,
          borderBottomWidth: 0,
          borderColor: Theme.GREY_LIGHT,
        };

        const borderActiveStyles = {
          borderWidth: 0,
          borderRightWidth: 1,
          borderLeftWidth: index === 0 ? 1 : 0,
          borderTopWidth: 5,
          borderTopColor: Theme.PRIMARY,
          borderRightColor: Theme.GREY_LIGHT,
          borderLeftColor: Theme.GREY_LIGHT,
        };

        const borderStyles = active
          ? borderActiveStyles
          : borderInactiveStyles;
        return (
          <TouchableWithoutFeedback
            key={route.key}
            onPress={() => {
              jumpToIndex(index);
              setActiveTab(index, route);
            }}
          >
            <View
              style={[styles.tab, {
                backgroundColor,
                ...borderStyles,
              }]}
            >
              <Text style={[styles.weekdayText, {
                color: textColor, fontFamily,
              }]}
              >
                {activeTab}
              </Text>
            </View>
          </TouchableWithoutFeedback>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: defaultScale(60),
    borderTopWidth: 0,
    borderBottomWidth: defaultScale(1),
    paddingTop: defaultScale(10),
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'center',
    borderColor: Theme.GREY_LIGHT,
  },
  tab: {
    flex: 1,
    padding: defaultScale(3),
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
  },
  weekdayText: {
    ...Theme.textStyle.bodyCopyReg,
    alignItems: 'center',
    color: Theme.GREY,
  },
});

export default MealDetailedViewTabs;
